import React, { useState } from 'react';
import './TabBar.scss';

const tabs = ['all', 'Pending payment', 'to be delivered', 'on the way', 'completed']; // The tab labels

const TabBar = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div className="tab-bar">
      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`tab-item ${activeTab === tab ? 'active' : ''}`}
          onClick={() => setActiveTab(tab)}
        >
          {tab}
        </div>
      ))}
    </div>
  );
};

export default TabBar;
